import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Field } from "@/components/common";
import { api, errMsg, CASH_MOVE_LABELS } from "@/lib/api";
import { toast } from "sonner";

export function MoveDialog({ type, sessionId, onClose, onDone }) {
  const [value, setValue] = useState("");
  const [note, setNote] = useState("");
  const submit = async () => {
    try {
      await api.post("/cash/movement", { type, amount: Number(value) || 0, note, session_id: sessionId });
      toast.success("Movimentação registrada");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="cash-move-modal">
        <DialogHeader><DialogTitle>{CASH_MOVE_LABELS[type]}</DialogTitle></DialogHeader>
        <Field label="Valor (R$)"><Input type="number" step="0.01" min="0" value={value} onChange={(e) => setValue(e.target.value)} className="h-11 font-mono" data-testid="cash-move-amount-input" /></Field>
        <Field label="Motivo / descrição"><Input value={note} onChange={(e) => setNote(e.target.value)} data-testid="cash-move-note-input" /></Field>
        <DialogFooter><Button onClick={submit} disabled={!(Number(value) > 0)} data-testid="cash-move-confirm-btn">Confirmar</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
